import { PARKINGS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: PARKINGS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkParkings'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/parkings/index.js